import { render, staticRenderFns } from "./ListItemMenuSelector.vue?vue&type=template&id=68826bf3"
import script from "./ListItemMenuSelector.vue?vue&type=script&lang=js"
export * from "./ListItemMenuSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports